import { render, staticRenderFns } from "./Hcpc.vue?vue&type=template&id=54daf66e"
import script from "./Hcpc.vue?vue&type=script&lang=js"
export * from "./Hcpc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports